import { ERouteName } from "@/router/router.type";

export enum EMixpanelEvent {
  // Common events
  APPLIANCE_TYPE_FILTER_APPLIED = "equipment_type_filter_applied",
  APPLIANCE_TYPE_FILTER_CLEARED = "equipment_type_filter_cleared",
  SECTION_CATEGORY_FILTER_APPLIED = "space_category_filter_applied",
  SECTION_CATEGORY_FILTER_CLEARED = "space_category_filter_cleared",

  // Sign up & login
  FORGOTTEN_PASSWORD = "forgotten_password",
  FORGOTTEN_PASSWORD_SUBMITTED = "forgotten_password_submitted",
  LANGUAGE_CHANGED = "language_changed",
  USER_LOGGED_IN = "user_logged_in",
  USER_LOGGED_OUT = "user_logged_out",
  USER_PASSWORD_SET = "user_password_set",

  // Contact
  CONTACT_VOLTALIS = "contact_voltalis",
  CONTACT_VOLTALIS_SENT = "contact_voltalis_sent",

  // Legacy piloting (planning overrides)
  MANUAL_CONTROL_CONFIGURATION = "manual_control_configuration",
  MANUAL_CONTROL_DELETED = "manual_control_deleted",
  MANUAL_CONTROL_PLANNED = "manual_control_planned",
  MANUAL_CONTROL_SECTION_LIST = "manual_control_section_list",
  MANUAL_CONTROL_SECTION_SEARCH_PERFORMED = "manual_control_section_search_performed",

  // Piloting (section planning)
  PILOTING_HOME_CARTO = "pilotage_home_carto",
  PILOTING_SITE_SEARCH_PERFORMED = "pilotage_site_search_performed",
  PLANNING_SECTION_LIST = "pilotage_space_list",
  PLANNING_SECTION_SEARCH_PERFORMED = "pilotage_space_search_performed",
  PROGRAMMING_RANGE_CREATED = "pilotage_applied",
  PROGRAMMING_RANGE_DELETED = "pilotage_ended",
  PROGRAMMING_RANGE_UPDATED = "pilotage_updated",
  PROGRAMMING_RANGE_DETAILS_VIEWED = "pilotage_details_viewed",

  // Programs
  CREATE_PROGRAM = "create_program",
  PROGRAM_COPIED = "program_copied",
  PROGRAM_CREATED = "program_created",
  PROGRAM_DELETED = "program_deleted",
  PROGRAM_DETAILS = "program_details",
  PROGRAM_DISABLED = "program_disabled",
  PROGRAM_ENABLED = "program_enabled",
  PROGRAM_RENAMED = "program_renamed",
  PROGRAM_SITE_SEARCH_PERFORMED = "program_site_search_performed",
  PROGRAM_UPDATED = "program_updated",
  PROGRAMMATION_HOME = "programmation_home",
  PROGRAMMATION_PROGRAM_LIST = "programmation_program_list",

  // Dashboard
  DASHBOARD_MONO = "dashboard_mono",
  DASHBOARD_MULTI = "dashboard_multi",

  // Consumption monitoring
  CONSUMPTION_MONITORING_DATE_RANGE_CHANGED = "consumption_monitoring_date_range_changed",
  CONSUMPTION_MONITORING_EVOLUTION_TAB = "consumption_monitoring_evolution_tab_viewed",
  CONSUMPTION_MONITORING_GLOBAL_TAB = "consumption_monitoring_global_tab_viewed",
  CONSUMPTION_MONITORING_HEATMAP = "consumption_monitoring_heatmap_viewed",
  CONSUMPTION_MONITORING_PER_M2 = "consumption_monitoring_per_m2_tab_viewed",
  CONSUMPTION_MONITORING_SITES_LIST = "consumption_monitoring_sitelist_viewed",
  CONSUMPTION_MONITORING_UPDATE_SECTION_PERIMETER = "consumption_hierarchy_space_perimeter_updated",

  // Section management
  SECTION_APPLIANCE_LIST_VIEWED = "space_equipment_list_viewed",
  SECTION_APPLIANCE_MOVED = "equipment_moved",
  SECTION_AREA_UPDATED = "space_area_updated",
  SECTION_CREATED = "space_created",
  SECTION_DELETED = "space_deleted",
  SECTION_DETAILS_VIEWED = "space_details_viewed",
  SECTION_MANAGEMENT_SEARCH_PERFORMED = "space_management_search_performed",
  SECTION_MOVED = "space_moved",
  SECTION_RENAMED = "space_renamed",
  SECTION_TREE_VIEWED = "space_tree_viewed",
  SECTION_UPDATED = "space_updated", // used on legacy site sections
  SITE_MANAGEMENT_HOME = "site_management_home",

  // Section category management
  SECTION_CATEGORY_CREATED = "space_category_created",
  SECTION_CATEGORY_RENAMED = "space_category_renamed",
  SECTION_CATEGORY_DELETED = "space_category_deleted",
  SECTION_CATEGORY_ASSIGNED_TO_SECTION = "space_category_assigned_to_space",

  // ***Deprecated*** legacy section management
  EDIT_SECTION = "edit_section",
  SECTIONS_MANAGEMENT_APPLIANCES_LIST = "sections_management_appliances_list",
  SECTIONS_MANAGEMENT_HOME = "sections_management_home",
  SECTIONS_MANAGEMENT_SECTION_LIST = "sections_management_section_list",
}

export const mixpanelPageViews: Partial<Record<ERouteName, EMixpanelEvent>> = {
  [ERouteName.CONSUMPTION_MONITORING]: EMixpanelEvent.CONSUMPTION_MONITORING_SITES_LIST,
  [ERouteName.PILOTING]: EMixpanelEvent.PILOTING_HOME_CARTO,
  [ERouteName.PLANNING]: EMixpanelEvent.PLANNING_SECTION_LIST,
  [ERouteName.PROGRAMMING]: EMixpanelEvent.PROGRAMMATION_HOME,
  [ERouteName.PROGRAMMING_DETAILS]: EMixpanelEvent.PROGRAM_DETAILS,
  [ERouteName.PROGRAMMING_LIST]: EMixpanelEvent.PROGRAMMATION_PROGRAM_LIST,
  [ERouteName.SECTION_MANAGEMENT]: EMixpanelEvent.SECTIONS_MANAGEMENT_HOME,
  [ERouteName.SECTION_MANAGEMENT_NEW]: EMixpanelEvent.SITE_MANAGEMENT_HOME,
  [ERouteName.SITE_SECTIONS]: EMixpanelEvent.SECTIONS_MANAGEMENT_SECTION_LIST,
  [ERouteName.SITE_SECTIONS_TREE]: EMixpanelEvent.SECTION_TREE_VIEWED,
};
